import { createAction, props } from "@ngrx/store";
import { INotasFiscaisReport } from "src/app/shared/interfaces/notasFiscaisReport/inotasfiscaisreport";

enum NotasFiscaisReportActionType {
    LOAD_NOTAS_FISCAIS_REPORT = '[notas fiscais] load notas fiscais report from api',
    LOAD_NOTAS_FISCAIS_REPORT_SUCCESS = '[notas fiscais] load notas fiscais report from api return success'
}


const loadNotasFiscaisReport = createAction(
    NotasFiscaisReportActionType.LOAD_NOTAS_FISCAIS_REPORT
);

const loadNotasFiscaisReportSuccess = createAction(
    NotasFiscaisReportActionType.LOAD_NOTAS_FISCAIS_REPORT_SUCCESS,
    props<{ notas_fiscais_report: INotasFiscaisReport }>()
);

export const notasFiscaisReportActions = {
    loadNotasFiscaisReport,
    loadNotasFiscaisReportSuccess
}